import { useTranslation } from 'react-i18next'
import styles from './MyDiscounts.module.scss'

import { useAuthState, useQuery } from '@percent/cause-dashboard/common/hooks'
import { Grid, Typography } from '@percent/lemonade'

import { useBreadcrumbs } from '../layout/breadcrumbsContext/useBreadcrumbs/useBreadcrumbs'

import { DiscountCard } from './DiscountCard/DiscountCard'
import { useServices } from '@percent/cause-dashboard/context/serviceContext/ServiceContext'
import { Loader } from '@percent/cause-dashboard/common/components'
import { applications } from './data/applications'
import { ErrorState } from './components/errorState/ErrorState'
import { EmptyState } from './components/emptyState/EmptyState'
import { DiscoverDiscounts } from '@percent/cause-dashboard/common/components/discoverDiscounts/DiscoverDiscounts'

export function MyDiscounts() {
  const { t } = useTranslation()
  const { storeService } = useServices()
  useBreadcrumbs([{ label: t('breadcrumb.myDiscounts') }])

  const { authState } = useAuthState()

  const queryParams = {
    accountId: authState.user?.id,
    organisationId: authState.claimOrganisation?.id
  }
  const [{ data: validationStatuses, isLoading, errorMessage, error }] = useQuery(
    storeService.getValidationSubmissions,
    queryParams
  )

  const allApplications = Object.values(applications).flat()

  if (isLoading) {
    return <Loader />
  }

  if (error) {
    return <ErrorState description={'myDiscounts.error.description'} />
  }

  const validations = validationStatuses?.data
    ? validationStatuses?.data
        .map(validation => {
          const application = allApplications.find(
            ({ configurationId, partnerId }) =>
              configurationId === validation.configurationId && partnerId === validation.partnerId
          )

          if (!application) return null

          return (
            <Grid.Col span={{ sm: 12, md: 6, lg: 4 }}>
              <DiscountCard validation={validation} application={application} />
            </Grid.Col>
          )
        })
        .filter(Boolean)
    : []

  return (
    <div id="marketplace-container">
      <div className={styles.myDiscountsWrapper}>
        <section title={t('myDiscounts.title')} className={styles.section} data-testid={t('myDiscounts.title')}>
          <DiscoverDiscounts />
          <div className={styles.sectionHeader}>
            {validations.length ? <div className={styles.sectionTitle}>{t('myDiscounts.title')}</div> : null}
            {validations.length ? (
              <div className={styles.sectionDescription}>{t('myDiscounts.description')}</div>
            ) : null}
          </div>
          {!validations.length ? (
            <EmptyState illustration="no-discounts" title={t('myDiscounts.noDiscounts.title')} />
          ) : (
            <Grid gutter={12}>
              {validations}
              {error && (
                <Typography style={{ marginLeft: '6px' }} variant="h6" $color="gray400">
                  {errorMessage}
                </Typography>
              )}
            </Grid>
          )}
        </section>
      </div>
    </div>
  )
}
